// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YT06","label":"styles_label__1Joek"};